export default __webpack_public_path__ + "static/media/iIcon.6b3361c3.svg";